import React from 'react'

import { Alert, Car, Heart, Profile3D, StarNoFill } from '@cinch/oxd-components/icons/src'
import Modal from '@cinch/oxd-components/modal/src'
import SVG from '@cinch/oxd-components/svg/src'
import { DEFAULT_GRADIENT_ID, GRADIENT_IDS } from '@cinch/oxd-components/svg/src'
import AuthButtons from '@cinch/oxd-containers/auth-buttons/src'
import GlobalContext from '@cinch/oxd-utils/context/src'
import tokens from '@cinch/oxd-utils/tokens/src'

import * as styles from './auth-modal.module.css'

import * as cardStyles from './card-styles.module.css'

import * as modalStyles from './modal-styles.module.css'

export interface AuthModalProps {
  isOpen: boolean
  handleClose: () => void
}

const HeartIcon = Heart as any
const StarIcon = StarNoFill as any
const CarIcon = Car as any
const AlertIcon = Alert as any
const size = tokens.customProperties.spacing.m
const gradientFill = `url(#${GRADIENT_IDS[DEFAULT_GRADIENT_ID]})`
const iconStyle = {
  display: 'inline-flex',
  width: size,
  height: size,
  fill: 'none',
  stroke: gradientFill,
  strokeWidth: 1,
}

const AuthModal: React.FC<AuthModalProps> = ({ isOpen, handleClose }) => (
  <>
    {isOpen && (
      <GlobalContext.Consumer>
        {({ authModal }: Cinch.Context) => (
          <Modal styles={modalStyles} cardStyles={cardStyles} title={authModal.title} onClose={handleClose}>
            <div className={styles.body}>
              <SVG className={styles.icon} children={Profile3D} />
              <ul className={styles.bullets}>
                <li className={styles.bullet}>
                  <HeartIcon
                    className={styles.bulletIcon}
                    role="presentation"
                    height={size}
                    width={size}
                    style={{ ...iconStyle, strokeWidth: 3 }}
                  />
                  {authModal.shortlist}
                </li>
                <li className={styles.bullet}>
                  <StarIcon
                    className={styles.bulletIcon}
                    role="presentation"
                    height={size}
                    width={size}
                    style={{ ...iconStyle, strokeWidth: 1.5 }}
                  />
                  {authModal.recommendations}
                </li>
                <li className={styles.bullet}>
                  <CarIcon
                    className={styles.bulletIcon}
                    role="presentation"
                    height={size}
                    width={size}
                    style={{
                      ...iconStyle,
                      fill: gradientFill,
                      stroke: 'none',
                    }}
                  />
                  {authModal.compare}
                </li>
                <li className={styles.bullet}>
                  <AlertIcon
                    className={styles.bulletIcon}
                    role="presentation"
                    height={tokens.customProperties.font.size.xs}
                    width={size}
                    style={{
                      ...iconStyle,
                      height: tokens.customProperties.font.size.xs,
                    }}
                  />
                  {authModal.features}
                </li>
              </ul>
            </div>
            <AuthButtons />
          </Modal>
        )}
      </GlobalContext.Consumer>
    )}
  </>
)

export default AuthModal
